var map = {
	"./App": 619,
	"./App.vue": 619,
	"./assets/about/Group.png": 91125,
	"./assets/about/Group2.png": 8693,
	"./assets/about/Group3.png": 6063,
	"./assets/about/food.png": 28332,
	"./assets/about/food2.jpeg": 77094,
	"./assets/about/pay.png": 46481,
	"./assets/about/people.png": 70517,
	"./assets/about/people2.png": 77282,
	"./assets/about/title.png": 44507,
	"./assets/about/title2.png": 43205,
	"./assets/about/title3.png": 20977,
	"./assets/about/title4.png": 20141,
	"./assets/baozang.gif": 29083,
	"./assets/browse/off-icon.png": 71070,
	"./assets/browse/search_icon.png": 43216,
	"./assets/browse/shop_car_empty.png": 41700,
	"./assets/contact/add.png": 84235,
	"./assets/contact/email.png": 4021,
	"./assets/contact/icon1.png": 1547,
	"./assets/contact/icon2.png": 74026,
	"./assets/contact/icon3.png": 65271,
	"./assets/contact/icon4.png": 82884,
	"./assets/contact/icon5.png": 20063,
	"./assets/contact/icon6.png": 73747,
	"./assets/contact/icon7.png": 62852,
	"./assets/contact/icon8.png": 52994,
	"./assets/contact/phone.png": 65545,
	"./assets/contact/wx.png": 86653,
	"./assets/contact/x.png": 93727,
	"./assets/cuisine/Asian/Asian1.png": 41743,
	"./assets/cuisine/Asian/Asian2.png": 74497,
	"./assets/cuisine/Asian/Asian3.png": 99246,
	"./assets/cuisine/Burgers/burgers1.png": 31646,
	"./assets/cuisine/Burgers/burgers2.png": 91352,
	"./assets/cuisine/Burgers/burgers3.png": 76317,
	"./assets/cuisine/Chinese/Chinese1.png": 41507,
	"./assets/cuisine/Chinese/Chinese2.png": 20165,
	"./assets/cuisine/Chinese/Chinese3.png": 11047,
	"./assets/cuisine/Indian/img1.png": 28883,
	"./assets/cuisine/Indian/img2.png": 6012,
	"./assets/cuisine/Indian/img3.png": 80543,
	"./assets/cuisine/Japanese/Japanese1.png": 80944,
	"./assets/cuisine/Japanese/Japanese2.png": 66233,
	"./assets/cuisine/Japanese/Japanese3.png": 1841,
	"./assets/cuisine/Kebabs/Kebabs1.png": 28698,
	"./assets/cuisine/Kebabs/Kebabs2.png": 40553,
	"./assets/cuisine/Korean/Korean1.png": 67475,
	"./assets/cuisine/Korean/Korean2.png": 22111,
	"./assets/cuisine/Korean/Korean3.png": 81347,
	"./assets/cuisine/Pizza/Pizza1.png": 30697,
	"./assets/cuisine/Pizza/Pizza2.png": 21411,
	"./assets/cuisine/Pizza/Pizza3.png": 64129,
	"./assets/cuisine/Thai/Thai1.png": 27375,
	"./assets/cuisine/Thai/Thai2.png": 75053,
	"./assets/cuisine/Thai/Thai3.png": 52715,
	"./assets/cuisine/cuisine_bg_1.png": 8823,
	"./assets/cuisine/cuisine_bg_2.png": 47473,
	"./assets/cuisine/cuisine_bg_3.png": 90375,
	"./assets/cuisine/cuisine_bg_4.png": 88619,
	"./assets/cuisine/cuisine_desc_demo.png": 29291,
	"./assets/flag/Flag_of_Portugal.png": 27822,
	"./assets/flag/Romania.png": 74837,
	"./assets/flag/Sweden.png": 87657,
	"./assets/flag/a-Austriaaodiliguoqi.png": 58100,
	"./assets/flag/a-Belgiumbilishiguoqi.png": 36894,
	"./assets/flag/a-Danmarkdanmaiguoqi.png": 68600,
	"./assets/flag/a-Finlandfenlanguoqi.png": 48503,
	"./assets/flag/a-Greekxilaguoqi.png": 88186,
	"./assets/flag/a-Holandhelanguoqi.png": 39522,
	"./assets/flag/a-Irelandaierlanguoqi.png": 55717,
	"./assets/flag/a-Italyyidaliguoqi.png": 83546,
	"./assets/flag/a-Norwaynuoweiguoqi.png": 8799,
	"./assets/flag/a-Swedenruidianguoqi.png": 18644,
	"./assets/flag/america.png": 17726,
	"./assets/flag/aodaliya.png": 73402,
	"./assets/flag/bingdao.png": 31030,
	"./assets/flag/canada.png": 16002,
	"./assets/flag/china.png": 86420,
	"./assets/flag/deguoguoqi.png": 55700,
	"./assets/flag/france.png": 50342,
	"./assets/flag/hungary.png": 72870,
	"./assets/flag/maerta.png": 76911,
	"./assets/flag/poland.png": 8222,
	"./assets/flag/ruishi.png": 30159,
	"./assets/flag/saipulusi.png": 67406,
	"./assets/flag/siluofake.png": 62404,
	"./assets/flag/siluowenniya.png": 15139,
	"./assets/flag/uk.png": 19086,
	"./assets/flag/xibanyaguoqi.png": 21799,
	"./assets/icon/book_icon.png": 88263,
	"./assets/icon/facebook.png": 3659,
	"./assets/icon/facebook.svg": 28395,
	"./assets/icon/google.png": 52012,
	"./assets/icon/heart.png": 99321,
	"./assets/icon/heart_fill.png": 97786,
	"./assets/icon/icon_card.png": 57912,
	"./assets/icon/icon_cash.png": 41875,
	"./assets/icon/icon_cash_eur.png": 53384,
	"./assets/icon/icon_fb.png": 77460,
	"./assets/icon/icon_ins.png": 22396,
	"./assets/icon/icon_paypal.png": 39887,
	"./assets/icon/icon_receipt.svg": 66467,
	"./assets/icon/icon_rights.png": 90685,
	"./assets/icon/icon_stripe.png": 34255,
	"./assets/icon/icon_tw.png": 2423,
	"./assets/icon/icon_viva.png": 14283,
	"./assets/icon/input_search.png": 77514,
	"./assets/icon/insta.svg": 72937,
	"./assets/icon/linkedin.png": 7328,
	"./assets/icon/linkedin.svg": 34199,
	"./assets/icon/sumb_down.png": 474,
	"./assets/icon/sumb_up.png": 18940,
	"./assets/icon/telegram.png": 35442,
	"./assets/icon/tiktok.svg": 30383,
	"./assets/icon/twitter.svg": 95218,
	"./assets/icon/whiteHeart.png": 18430,
	"./assets/icon/x.png": 20882,
	"./assets/icon/youyube.svg": 1198,
	"./assets/iconfont/iconfont": 99689,
	"./assets/iconfont/iconfont.css": 48793,
	"./assets/iconfont/iconfont.js": 99689,
	"./assets/iconfont/iconfont.json": 13469,
	"./assets/iconfont/iconfont.ttf": 30583,
	"./assets/iconfont/iconfont.woff": 92443,
	"./assets/iconfont/iconfont.woff2": 31733,
	"./assets/images/cuiseNot.png": 82301,
	"./assets/images/discount.png": 28109,
	"./assets/images/download_modal_bg.png": 34341,
	"./assets/images/food.png": 85140,
	"./assets/images/google_download.png": 86481,
	"./assets/images/img_home.png": 4103,
	"./assets/images/ios_download.png": 6919,
	"./assets/images/live_chat.png": 88981,
	"./assets/images/location.png": 14752,
	"./assets/images/login_bg.png": 20168,
	"./assets/images/menu-cuise.png": 37881,
	"./assets/images/mobile_banner.png": 995,
	"./assets/images/notfoundBg.png": 49465,
	"./assets/images/order_tips_download.jpg": 19385,
	"./assets/images/profile_default.png": 89809,
	"./assets/images/quotation.png": 37614,
	"./assets/images/right.png": 9602,
	"./assets/images/search.png": 17561,
	"./assets/images/skiLogo.png": 23857,
	"./assets/images/special.png": 69861,
	"./assets/index/app_download_bg.png": 7462,
	"./assets/index/download_index_mobile.png": 31824,
	"./assets/index/icon_index_1.png": 91793,
	"./assets/index/icon_index_2.png": 22973,
	"./assets/index/icon_index_3.png": 78256,
	"./assets/index/icon_index_cate2.png": 44938,
	"./assets/index/icon_index_cate3.png": 77797,
	"./assets/index/index_card.png": 6000,
	"./assets/logo-merchant.png": 42171,
	"./assets/logo.png": 66949,
	"./assets/menu/Shop_light.png": 55523,
	"./assets/menu/empty_cart.png": 4464,
	"./assets/menu/empty_cart2.png": 88756,
	"./assets/menu/empty_cart3.png": 42737,
	"./assets/menu/fhrs_0_en-gb.jpg": 71270,
	"./assets/menu/fhrs_1_en-gb.jpg": 51507,
	"./assets/menu/fhrs_2_en-gb.jpg": 43779,
	"./assets/menu/fhrs_3_en-gb.jpg": 8891,
	"./assets/menu/fhrs_4_en-gb.jpg": 67091,
	"./assets/menu/fhrs_5_en-gb.jpg": 71266,
	"./assets/menu/fhrs_AI_en-gb.jpg": 40,
	"./assets/menu/fhrs_IR_en-gb.jpg": 65974,
	"./assets/menu/fhrs_P_en-gb.jpg": 25870,
	"./assets/menu/fhrs_pass_en-gb.jpg": 48778,
	"./assets/menu/icon_bounds.png": 17404,
	"./assets/menu/icon_eur.png": 42088,
	"./assets/menu/menu_bg_1.png": 87573,
	"./assets/menu/menu_bg_2.png": 27567,
	"./assets/menu/menu_bg_3.png": 70808,
	"./assets/menu/modal_delivery.png": 24513,
	"./assets/menu/modal_dinein.png": 27580,
	"./assets/menu/modal_pickup.png": 77264,
	"./assets/menu/price-fill.svg": 30194,
	"./assets/merchant_pageloading.gif": 70435,
	"./assets/page_loading.gif": 9635,
	"./assets/points/award.png": 88886,
	"./assets/points/point.png": 26951,
	"./assets/policy/faqs_bg.png": 44041,
	"./components/BrowseComps/AddressSearchInput": 49006,
	"./components/BrowseComps/AddressSearchInput.vue": 49006,
	"./components/BrowseComps/BrowseMerchantBox": 17897,
	"./components/BrowseComps/BrowseMerchantBox.vue": 17897,
	"./components/BrowseComps/BrowseSortBox": 49132,
	"./components/BrowseComps/BrowseSortBox.vue": 49132,
	"./components/BrowseComps/ChooseAddressModal": 14645,
	"./components/BrowseComps/ChooseAddressModal.vue": 14645,
	"./components/BrowseComps/TagBar": 48237,
	"./components/BrowseComps/TagBar.vue": 48237,
	"./components/CheckoutComps/AddressBox": 26955,
	"./components/CheckoutComps/AddressBox.vue": 26955,
	"./components/CheckoutComps/CheckLoginBlock": 6981,
	"./components/CheckoutComps/CheckLoginBlock.vue": 6981,
	"./components/CheckoutComps/CheckoutCartBox": 30339,
	"./components/CheckoutComps/CheckoutCartBox.vue": 30339,
	"./components/CheckoutComps/DateTimePicker": 77815,
	"./components/CheckoutComps/DateTimePicker.vue": 77815,
	"./components/CheckoutComps/PaymentBox": 45067,
	"./components/CheckoutComps/PaymentBox.vue": 45067,
	"./components/CloudFlareVerify": 28265,
	"./components/CloudFlareVerify.vue": 28265,
	"./components/CooikeDiv": 97908,
	"./components/CooikeDiv.vue": 97908,
	"./components/CustomerService": 21606,
	"./components/CustomerService.vue": 21606,
	"./components/DownloadAppModal": 4407,
	"./components/DownloadAppModal.vue": 4407,
	"./components/Footer": 18498,
	"./components/Footer.vue": 18498,
	"./components/Header": 96056,
	"./components/Header.vue": 96056,
	"./components/IndexComps/CategoryIndex": 40802,
	"./components/IndexComps/CategoryIndex.vue": 40802,
	"./components/IndexComps/DownloadBox": 81096,
	"./components/IndexComps/DownloadBox.vue": 81096,
	"./components/IndexComps/FaqsBox": 34174,
	"./components/IndexComps/FaqsBox.vue": 34174,
	"./components/IndexComps/MerchantBox": 89874,
	"./components/IndexComps/MerchantBox.vue": 89874,
	"./components/JudgeScreenMask": 10906,
	"./components/JudgeScreenMask.vue": 10906,
	"./components/LoadErrorModal": 22558,
	"./components/LoadErrorModal.vue": 22558,
	"./components/MenuComps/CartBox": 83637,
	"./components/MenuComps/CartBox.vue": 83637,
	"./components/MenuComps/CategoryBox": 42726,
	"./components/MenuComps/CategoryBox.vue": 42726,
	"./components/MenuComps/MenuBox": 7093,
	"./components/MenuComps/MenuBox.vue": 7093,
	"./components/MenuComps/MerchantOffMobile": 64822,
	"./components/MenuComps/MerchantOffMobile.vue": 64822,
	"./components/MenuComps/ShopStatus": 98973,
	"./components/MenuComps/ShopStatus.vue": 98973,
	"./components/MerchantItem": 38474,
	"./components/MerchantItem.vue": 38474,
	"./components/MyComps/Account": 95849,
	"./components/MyComps/Account.vue": 95849,
	"./components/MyComps/Address": 91754,
	"./components/MyComps/Address.vue": 91754,
	"./components/MyComps/Booking": 11711,
	"./components/MyComps/Booking.vue": 11711,
	"./components/MyComps/Favorite": 15658,
	"./components/MyComps/Favorite.vue": 15658,
	"./components/MyComps/Orders": 44065,
	"./components/MyComps/Orders.vue": 44065,
	"./components/MyComps/Points": 89251,
	"./components/MyComps/Points.vue": 89251,
	"./components/PageLoading": 39311,
	"./components/PageLoading.vue": 39311,
	"./components/PhoneBtn": 25912,
	"./components/PhoneBtn.vue": 25912,
	"./components/Verifition/Verify": 42846,
	"./components/Verifition/Verify.vue": 42846,
	"./components/Verifition/Verify/VerifyPoints": 77082,
	"./components/Verifition/Verify/VerifyPoints.vue": 77082,
	"./components/Verifition/Verify/VerifySlide": 85629,
	"./components/Verifition/Verify/VerifySlide.vue": 85629,
	"./components/Verifition/api": 75398,
	"./components/Verifition/api/": 75398,
	"./components/Verifition/api/index": 75398,
	"./components/Verifition/api/index.js": 75398,
	"./components/Verifition/utils/ase": 50587,
	"./components/Verifition/utils/ase.js": 50587,
	"./components/Verifition/utils/util": 86978,
	"./components/Verifition/utils/util.js": 86978,
	"./config": 61073,
	"./config/": 61073,
	"./config/index": 61073,
	"./config/index.js": 61073,
	"./main": 50866,
	"./main.js": 50866,
	"./mixins/judgeScreenH5": 47932,
	"./mixins/judgeScreenH5.js": 47932,
	"./request": 97344,
	"./request/": 97344,
	"./request/index": 97344,
	"./request/index.js": 97344,
	"./router": 1120,
	"./router/": 1120,
	"./router/index": 1120,
	"./router/index.js": 1120,
	"./utils/app": 38096,
	"./utils/app.js": 38096,
	"./utils/bus": 80333,
	"./utils/bus.js": 80333,
	"./utils/debounce": 56171,
	"./utils/debounce.js": 56171,
	"./utils/getPickTimeList": 64751,
	"./utils/getPickTimeList.js": 64751,
	"./utils/jsencrypt": 41051,
	"./utils/jsencrypt.js": 41051,
	"./utils/judgeUseGoogle": 60516,
	"./utils/judgeUseGoogle.js": 60516,
	"./utils/manageCart": 50708,
	"./utils/manageCart.js": 50708,
	"./utils/payment": 11974,
	"./utils/payment.js": 11974,
	"./utils/seo": 56527,
	"./utils/seo.js": 56527,
	"./views": 15220,
	"./views/": 15220,
	"./views/404": 96740,
	"./views/404.vue": 96740,
	"./views/about": 46389,
	"./views/about/": 46389,
	"./views/about/components/BoxFive": 57177,
	"./views/about/components/BoxFive.vue": 57177,
	"./views/about/components/BoxFour": 4324,
	"./views/about/components/BoxFour.vue": 4324,
	"./views/about/components/BoxOne": 96564,
	"./views/about/components/BoxOne.vue": 96564,
	"./views/about/components/BoxSix": 74634,
	"./views/about/components/BoxSix.vue": 74634,
	"./views/about/components/BoxThree": 87269,
	"./views/about/components/BoxThree.vue": 87269,
	"./views/about/components/BoxTwo": 41113,
	"./views/about/components/BoxTwo.vue": 41113,
	"./views/about/index": 46389,
	"./views/about/index.vue": 46389,
	"./views/browse/browse": 44683,
	"./views/browse/browse.vue": 44683,
	"./views/category": 43322,
	"./views/category/": 43322,
	"./views/category/foodInfo": 62808,
	"./views/category/foodInfo.js": 62808,
	"./views/category/index": 43322,
	"./views/category/index.vue": 43322,
	"./views/checkout": 27641,
	"./views/checkout.vue": 27641,
	"./views/contact": 95964,
	"./views/contact/": 95964,
	"./views/contact/index": 95964,
	"./views/contact/index.vue": 95964,
	"./views/demo": 22680,
	"./views/demo.vue": 22680,
	"./views/develop": 35393,
	"./views/develop/": 35393,
	"./views/develop/index": 35393,
	"./views/develop/index.vue": 35393,
	"./views/index": 15220,
	"./views/index.vue": 15220,
	"./views/login": 22170,
	"./views/login.vue": 22170,
	"./views/menu": 13698,
	"./views/menu.vue": 13698,
	"./views/my/editAddress": 53721,
	"./views/my/editAddress.vue": 53721,
	"./views/my/my": 56322,
	"./views/my/my.vue": 56322,
	"./views/my/mySecond": 62943,
	"./views/my/mySecond.vue": 62943,
	"./views/payment/appPayCenter": 94391,
	"./views/payment/appPayCenter.vue": 94391,
	"./views/payment/guavaPay": 23934,
	"./views/payment/guavaPay.vue": 23934,
	"./views/payment/orderSuccess": 98110,
	"./views/payment/orderSuccess.vue": 98110,
	"./views/payment/payDelay": 62555,
	"./views/payment/payDelay.vue": 62555,
	"./views/payment/payFail": 2470,
	"./views/payment/payFail.vue": 2470,
	"./views/payment/paypal": 54109,
	"./views/payment/paypal.vue": 54109,
	"./views/payment/paypalAdvance": 94364,
	"./views/payment/paypalAdvance.vue": 94364,
	"./views/payment/stripe": 66853,
	"./views/payment/stripe.vue": 66853,
	"./views/payment/trustPayment": 22409,
	"./views/payment/trustPayment.vue": 22409,
	"./views/payment/trustPaymentJs": 31233,
	"./views/payment/trustPaymentJs.vue": 31233,
	"./views/payment/vivaWallet": 64317,
	"./views/payment/vivaWallet.vue": 64317,
	"./views/policy/cookiePolicy": 77935,
	"./views/policy/cookiePolicy.vue": 77935,
	"./views/policy/faqs": 8161,
	"./views/policy/faqs.vue": 8161,
	"./views/policy/private": 79155,
	"./views/policy/private.vue": 79155,
	"./views/policy/refundAndCancellations": 87765,
	"./views/policy/refundAndCancellations.vue": 87765,
	"./views/policy/termsAndConditions": 63369,
	"./views/policy/termsAndConditions.vue": 63369,
	"./views/quick/quickLogin": 81364,
	"./views/quick/quickLogin.vue": 81364,
	"./views/review": 6649,
	"./views/review.vue": 6649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;